import Field from './Field';

export default class extends Field {
    constructor(element, parent, props) {
        super(element, parent, props);

        this.getInput().on('input', this.onSlideMove.bind(this));
        this.updatePercentageReadout();
    }

    onSlideMove() {
        this.updatePercentageReadout();
    }

    updatePercentageReadout() {
        const displayValue = this._props.percentage
            ? Math.round(this.getValue() * 100) + '%'
            : this.getValue();

        this.find('.percentage_readout').html(displayValue);
    }

    setValue(value = '') {
        this._input.prop('checked', !!Number(value));
        return this;
    }
    getValue() {
        const value = super.getValue();
        return value ? value : 0;
    }
}
